import React from 'react';
import {Offline} from 'react-detect-offline';

import * as localizationKeys from '../../../consts/localization/localizationKeys';
import log from '../../../services/logger/log';
import networkStatusService from '../../../services/networkStatusService';
import {setIsNetworkOnline, setNotificationInfo, setNotificationSuccess} from '../../../state/ducks/global';
import {dispatch} from '../../../state/store';

const OfflineDetector = () => {
    const onChange = (isOnline) => {
        dispatch(setIsNetworkOnline(isOnline));
        if (isOnline) {
            dispatch(setNotificationSuccess({textKey: localizationKeys.GLOBAL_DETECTOR_ONLINE}));
            networkStatusService.setIsOnline();
            log.resetLogger();
            log.info(`OfflineDetector: Internet connection is online`);
        } else {
            dispatch(setNotificationInfo({textKey: localizationKeys.GLOBAL_DETECTOR_OFFLINE}));
            networkStatusService.setIsOffline();
            log.info(`OfflineDetector: Internet connection is offline`);
        }
    };

    const pollingUrl = process.env.PUBLIC_URL + '/storage/polling.png';

    return (
        <Offline
            polling={{
                interval: 10000,
                url: pollingUrl,
            }}
            onChange={onChange}
        />
    );
};

export default OfflineDetector;
